var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.65454 2.72727C6.65454 2.32561 6.98015 2 7.38181 2H12.6182C13.0198 2 13.3455 2.32561 13.3455 2.72727C13.3455 3.12893 13.0198 3.45455 12.6182 3.45455H7.38181C6.98015 3.45455 6.65454 3.12893 6.65454 2.72727ZM2 5.34545C2 4.94379 2.32561 4.61818 2.72727 4.61818H17.2727C17.6744 4.61818 18 4.94379 18 5.34545C18 5.74712 17.6744 6.07273 17.2727 6.07273H16.2545V14.6545C16.2545 16.5108 14.7653 18 12.9091 18H7.0909C5.2217 18 3.74545 16.4976 3.74545 14.5818V6.07273H2.72727C2.32561 6.07273 2 5.74712 2 5.34545ZM5.2 6.07273V14.5818C5.2 15.7206 6.05102 16.5455 7.0909 16.5455H12.9091C13.962 16.5455 14.8 15.7074 14.8 14.6545V6.07273H5.2ZM8.03637 7.96364C8.43803 7.96364 8.76364 8.28925 8.76364 8.69091V14C8.76364 14.4017 8.43803 14.7273 8.03637 14.7273C7.6347 14.7273 7.30909 14.4017 7.30909 14V8.69091C7.30909 8.28925 7.6347 7.96364 8.03637 7.96364ZM11.9636 7.96364C12.3653 7.96364 12.6909 8.28925 12.6909 8.69091V14C12.6909 14.4017 12.3653 14.7273 11.9636 14.7273C11.562 14.7273 11.2364 14.4017 11.2364 14V8.69091C11.2364 8.28925 11.562 7.96364 11.9636 7.96364Z",
    fill: "#DE1414",
    stroke: "#DE1414",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinRedIcon);
export default __webpack_public_path__ + "static/media/bin-red-icon.c76d88e0f2e7a09bc1e7deb308b684a2.svg";
export { ForwardRef as ReactComponent };